import React from 'react';
import AisinoForm from "./baseComponent/form/AisinoForm";
import AisinoModal from "./baseComponent/modal/AisinoModal";
import {getLanguage, validateMessages} from "./source/js/common";
import AisinoButtonArea from "./common/area/AisinoButtonArea";
import AisinoButton from "./baseComponent/button/AisinoButton";
import {AisinoPassword} from "./baseComponent/form";
import AisinoFormItem from "./baseComponent/form/AisinoFormItem";
import AisinoInput from "./baseComponent/form/input/AisinoInput";
import AisinoInputAndButton from "./baseComponent/form/input/AisinoInputAndButton";
import CheckSquareOutlined from "@ant-design/icons/es/icons/CheckSquareOutlined";
import CloseSquareOutlined from "@ant-design/icons/es/icons/CloseSquareOutlined";
import {postSync} from "./common/utils/http";
import {aisinoErrorModal, aisinoInfoModal, aisinoSuccessOperatedModal} from "./common/modal/AisinoModalMethod";
import {isEmpty, pwdCheck} from "./common/utils/StringUtils";

const formLayout = {
    labelCol: {span: 6},
    wrapperCol: {
        xs: {span:10,offset: 0},
        sm: {span:10,offset: 2},
        md: {span:10,offset: 2},
        lg: {span:10,offset: 2}
    }
};
const itemLayout={
    wrapperCol: {
        xs: {span:12,offset: 0},
        sm: {span:12,offset: 2},
        md: {span:12,offset: 2},
        lg: {span:12,offset: 2}
    }
}
const commonLan = require('./constant/js/formItemNameLabel/'+getLanguage()+'/common.js');
const loginLan = require('./constant/js/formItemNameLabel/'+getLanguage()+'/login.js');
class ForgetPwd extends React.Component {
    constructor(props){
        super(props);
        this.state={
            visible:false,
            otpBtnStatus:false,
            otpIntervalId:'',
            prevSeconds:60
        }
        this.formRef=React.createRef();
    }

    setModal1Visible(flag){
        if(flag){
            this.formRef.current.resetFields();
        }
        this.setState({
            visible:flag
        })
    }
    submitForgetPwd(){
        const that = this;
        const form = that.formRef.current;
        form.validateFields().then(values => {
            postSync("aisino/portalIndex/forgetPwdChangePwd",values).then(response=>{
                if(response){
                    if(response==='1'){
                        aisinoInfoModal(commonLan.emailNotEmpty);
                        return;
                    }
                    if(response==='2'){
                        aisinoInfoModal(commonLan.otpNotEmpty);
                        return;
                    }
                    if(response==='3'){
                        aisinoInfoModal(commonLan.otpExpired);
                        return;
                    }
                    if(response==='4'){
                        aisinoInfoModal(commonLan.otpIncorrect);
                        return;
                    }
                    if(response==='5'){
                        aisinoInfoModal(commonLan.accountNotExist);
                        return;
                    }
                    aisinoSuccessOperatedModal(function(){
                        that.setState({
                            visible:false
                        })
                    });
                }else{
                    aisinoErrorModal();
                }
            })
        })
    }
    cancel(){
        this.setState({
            visible:false
        })
    }
    sendOtp(){
        const that = this;
        const form = that.formRef.current;
        if(form.getFieldError("email").length){
            return;
        }
        if(isEmpty(form.getFieldValue("email"))){
            form.validateFields(["email"])
            return;
        }
        let formData = form.getFieldsValue();

        postSync("aisino/portalIndex/accountCheck",{email:formData.email}).then(res=>{
            if(res){
                postSync("aisino/portalIndex/sendOTP",{email:formData.email}).then(response=>{
                    if(response){
                        if(response==='1'){
                            aisinoInfoModal(commonLan.emailNotEmpty);
                            return ;
                        }
                        if(response==='2'){
                            aisinoInfoModal(commonLan.emailIncorrect);
                            return ;
                        }
                        that.state.otpBtnStatus=true;
                        that.state.prevSeconds=Number(response);
                        that.setState({})
                        that.state.otpIntervalId=setInterval(() => {
                            that.state.prevSeconds=that.state.prevSeconds-1;
                            if(that.state.prevSeconds===0){
                                that.state.otpBtnStatus=false;
                                clearInterval(that.state.otpIntervalId)
                            }
                            that.setState({})
                        }, 1000);
                    }
                })
            }else{
                aisinoInfoModal(commonLan.accountNotExist);
            }
        })

    }
    newpwdChange(){
        const form =this.formRef.current;
        if(form.getFieldValue("newpwdagain")){
            form.validateFields(["newpwdagain"]);
        }
    }
    render() {
        const{otpBtnStatus,prevSeconds} = this.state;
        let buttonModules=[
            <AisinoButton type="primary" icon={<CheckSquareOutlined/>} onClick={()=>this.submitForgetPwd()} >{commonLan.submitButton.label}</AisinoButton>,
            <AisinoButton htmlType="button" icon={<CloseSquareOutlined/>} onClick={()=>this.cancel()}>{commonLan.cancelButton.label}</AisinoButton>,
        ];
        return(
            <AisinoModal
                title={loginLan.forgetPassword}
                style={{ top: 20 }}
                visible={this.state.visible}
                onOk={() => this.setModal1Visible(false)}
                onCancel={() => this.setModal1Visible(false)}
                forceRender={true}
                width={600}
                maskClosable={false}
                footer={null}>
                <AisinoForm {...formLayout} validateMessages={validateMessages()}
                            ref={this.formRef}>
                    <AisinoFormItem maxLength={100} {...itemLayout} name={"email"} label={loginLan.email.label}   rules={[{required: true},{type:"email"},{max:100}]}>
                        <AisinoInputAndButton button_content={otpBtnStatus?prevSeconds+loginLan.second:loginLan.sendOTP.label} placeholder={loginLan.enterEmail} button_disabled={otpBtnStatus} button_click={()=>this.sendOtp()} />
                    </AisinoFormItem>
                    <AisinoFormItem  name={"otp"} label={"OTP"} rules={[{required: true}]}>
                        <AisinoInput maxLength={6} placeholder={loginLan.enterOTP}/>
                    </AisinoFormItem>
                    <div id={"forgetPwdNote"}>
                        <span>{loginLan.note}</span>
                    </div>
                    <AisinoFormItem label={loginLan.newPassword} name={"newpwd"} rules={[{required: true},
                        ({getFieldValue}) => ({
                            validator(rule, value) {
                                if(value){
                                    let res = pwdCheck(value);
                                    if(res === 3){
                                        return  Promise.reject(commonLan.pwdIncorrect);
                                    }
                                    else if(res === 1){
                                        return  Promise.reject(commonLan.pwdHasSpecialCharacter);
                                    }
                                    else{
                                        return Promise.resolve();
                                    }
                                }
                                return Promise.resolve();
                            },
                        })
                        ]} onChange={()=>this.newpwdChange()}>
                        <AisinoPassword  maxLength={20} placeholder={commonLan.pwdFormatIncorrect}/>
                    </AisinoFormItem>
                    <AisinoFormItem label={loginLan.confirmPassword} name={"newpwdagain"} rules={[{required: true},
                        ({getFieldValue}) => ({
                            validator(rule, value) {
                                if(value && value !==getFieldValue('newpwd')){
                                    return  Promise.reject(commonLan.passwordIsDifferentFromNewPassword);
                                }
                                return Promise.resolve();
                            },
                        })
                    ]}>
                        <AisinoPassword maxLength={20} placeholder={commonLan.pwdFormatIncorrect}/>
                    </AisinoFormItem>
                    <div className="pageBottomButtonBg">
                        <AisinoButtonArea buttonModules={buttonModules} style={{justifyContent: "center"}}/>
                    </div>
                </AisinoForm>
            </AisinoModal>
        )
    }


}
export default ForgetPwd;
